
import { Navigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { GraduationCap, Users, Activity } from 'lucide-react';

export default function Landing() {
  const { user } = useAuth();

  // Si el usuario ya está autenticado, redirigir al dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full space-y-8">
        {/* Header */}
        <div className="text-center space-y-4">
          <div className="flex justify-center mb-6">
            <div className="bg-primary rounded-full p-4">
              <GraduationCap className="w-12 h-12 text-primary-foreground" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground">
            Colegio Corazonistas Haro
          </h1>
          <p className="text-xl text-muted-foreground">
            Sistema de Gestión de Actividades Extraescolares
          </p>
        </div>

        {/* Main Card */}
        <Card className="shadow-lg">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl">Acceso al Sistema</CardTitle>
            <CardDescription className="text-base">
              Gestiona la asistencia y administra las actividades extraescolares del centro
            </CardDescription>
          </CardHeader>
          
          <CardContent className="space-y-6">
            {/* Features */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex items-center space-x-3 p-3 rounded-lg bg-accent/50">
                <Users className="w-5 h-5 text-primary" />
                <span className="text-sm">Gestión de Alumnos</span>
              </div>
              <div className="flex items-center space-x-3 p-3 rounded-lg bg-accent/50">
                <Activity className="w-5 h-5 text-primary" />
                <span className="text-sm">Control de Asistencia</span>
              </div>
            </div>

            {/* Access Button */}
            <div className="text-center pt-4">
              <Button 
                size="lg" 
                className="px-8 py-4 text-lg font-semibold"
                onClick={() => window.location.href = '/auth'}
              >
                <GraduationCap className="w-5 h-5 mr-2" />
                Acceder al Sistema
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* Footer */}
        <div className="text-center text-sm text-muted-foreground">
          <p>Sistema interno del Colegio Corazonistas Haro</p>
        </div>
      </div>
    </div>
  );
}
